<template>
    <div>
        <welcome-img/>
        <!--<welcome/>-->
        <alumni-stories/>
        <alumni-m-v-v/>

        <alum-numbers/>
        <upcoming-events/>
        <!--<alumni-links/>
        <share-story/>-->


        <!--<alumni-benfits/>-->
    </div>
</template>

<script>
    import WelcomeImg from "../components/alumni/welcomeImg";
    import Welcome from "../components/alumni/welcome";
    import AlumniStories from "../components/alumni/alumniStories";
    import ShareStory from "../components/alumni/shareStory";
    import AlumniBenfits from "../components/alumni/alumniBenfits";
    import UpcomingEvents from "../components/home/upcomingEvents";
    import AlumniLinks from "../components/alumni/alumniLinks";
    import AlumNumbers from "../components/alumni/alumNumbers";
    import AlumniMVV from "../components/alumni/AlumniMVV";
    export default {
        name: "Alumni",
        components: {
            AlumniMVV,
            AlumNumbers,
            AlumniLinks, UpcomingEvents, AlumniBenfits, ShareStory, AlumniStories, Welcome, WelcomeImg}
    }
</script>

<style scoped>

</style>